export const getTeamsIntegrations = (state) => {
  return state.integrations.filter((integration) => {
    return integration.type === 'teams';
  });
};

export const getSlackIntegrations = (state) => {
  return state.integrations.filter((integration) => {
    return integration.type === 'slack';
  });
};
